// src/pages/Admin/StudentEdit.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import TitleWithBack from '../../components/common/TitleWithBack';

function StudentEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [tooltip, setTooltip] = useState('');
  const [form, setForm] = useState({
    studentName: '',
    email: '',
    program: '',
    examCenter: '',
    registrationNumber: '',
    yearOfStudy: '',
    semester: '',
    status: ''
  }); 
  const [programs, setPrograms] = useState([]);
  const [examCentres, setExamCentres] = useState([]);
  const [years, setYears] = useState([]);
  const [semesters, setSemesters] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const [studentRes, progRes, centreRes, yearRes, semRes] = await Promise.all([
          axios.get(`/api/students/${id}`),
          axios.get('/api/programs'),
          axios.get('/api/exam-centres'),
          axios.get('/api/years-of-study'),
          axios.get('/api/semesters')
        ]);
        const studentData = studentRes.data;
        const formData = {
          studentName: studentData.name || '',
          email: studentData.email || '',
          program: studentData.program?.id || '',
          examCenter: studentData.examCenter?.id || '',
          registrationNumber: studentData.registrationNumber || '',
          yearOfStudy: studentData.yearOfStudy?.id || '',
          semester: studentData.semester?.id || '',
          status: studentData.status || ''
        }; 
        setForm(formData);
        setPrograms(Array.isArray(progRes.data) ? progRes.data : (progRes.data.data || []));
        setExamCentres(Array.isArray(centreRes.data) ? centreRes.data : (centreRes.data.data || []));
        setYears(Array.isArray(yearRes.data) ? yearRes.data : (yearRes.data.data || []));
        setSemesters(Array.isArray(semRes.data) ? semRes.data : (semRes.data.data || []));
      } catch (err) {
        setTooltip('Error fetching student details.');
      }    
    }
    fetchData();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      name: form.studentName,
      email: form.email,
      program: { id: form.program },
      examCenter: { id: form.examCenter },
      registrationNumber: form.registrationNumber,
      yearOfStudy: { id: form.yearOfStudy },
      semester:  { id: form.semester },
      status: form.status
    };
    console.log(payload);
    try {
      await axios.put(`/api/students/${id}`, payload);
      setTooltip('Student updated successfully!');
      setTimeout(() => navigate('/admin/students/view'), 2000);
    } catch (err) {
      setTooltip('Error updating student.');
    }
  };

  return (
    <div className="container mt-2">
      <TitleWithBack title="Edit Student" />
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Student Name:</label>
          <input 
            type="text" 
            name="studentName" 
            value={form.studentName} 
            onChange={handleChange} 
            className="form-control" 
            required 
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Email:</label>
          <input 
            type="email" 
            name="email" 
            value={form.email} 
            onChange={handleChange} 
            className="form-control" 
            required 
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Program:</label>
          <select 
            name="program" 
            value={form.program} 
            onChange={handleChange} 
            className="form-select" 
            required
          >
            <option value="">Select Program</option>
            {programs.map(p => (
              <option key={p.id} value={p.id}>{p.name}</option>
            ))}
          </select>
        </div>
        <div className="mb-3">
          <label className="form-label">Exam Centre:</label>
          <select 
            name="examCenter" 
            value={form.examCenter} 
            onChange={handleChange} 
            className="form-select" 
            required
          >
            <option value="">Select Exam Centre</option>
            {examCentres.map(ec => (
              <option key={ec.id} value={ec.id}>{ec.centreName}</option>
            ))}
          </select>
        </div>
        <div className="mb-3">
          <label className="form-label">Registration Number:</label>
          <input 
            type="text" 
            name="registrationNumber" 
            value={form.registrationNumber} 
            onChange={handleChange} 
            className="form-control"
            required 
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Year of Study:</label>
          <select 
            name="yearOfStudy" 
            value={form.yearOfStudy} 
            onChange={handleChange} 
            className="form-select"
            required
          >
            <option value="">Select Year</option>
            {years.map(y => (
              <option key={y.id} value={y.id}>{y.name}</option>
            ))}
          </select>
        </div>
        <div className="mb-3">
          <label className="form-label">Semester:</label>
          <select 
            name="semester" 
            value={form.semester} 
            onChange={handleChange} 
            className="form-select"
            required
          >
            <option value="">Select Semester</option>
            {semesters.map(s => (
              <option key={s.id} value={s.id}>{s.name}</option>
            ))}
          </select>
        </div>
        <div className="mb-3">
          <label className="form-label">Status:</label>
          <select 
            name="status" 
            value={form.status} 
            onChange={handleChange} 
            className="form-select"
            required
          >
            <option value="">Select Status</option>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>
        <button type="submit" className="btn btn-primary">Update Student</button>
      </form>
      {tooltip && (
        <div className={`mt-3 alert ${tooltip.startsWith('Error') ? 'alert-danger' : 'alert-success'}`}>
          {tooltip}
        </div>
      )}
    </div>
  );
}

export default StudentEdit;
